export function ErrorPage() {
  // const error = useRouteError();
  return <div>404</div>;
}
